import axios from 'axios'
import { useAuthStore } from '../store/auth'

// API 基础 URL
// 本地开发使用相对路径，生产环境使用 Worker 的完整 URL
const FALLBACK_API_BASE_URL = 'https://kaying-cf-store-api.wordsvideo2025.workers.dev/api/v1'
export const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || FALLBACK_API_BASE_URL

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// 请求拦截器 - 添加token
apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 响应拦截器 - 处理错误
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 只在 401 时清除状态，不自动跳转，让页面自己处理错误显示
    if (error.response?.status === 401) {
      useAuthStore.getState().logout()
      // 不自动跳转，让调用方处理
    }
    return Promise.reject(error)
  }
)

export default apiClient
